import { ClientInput } from 'admin/inputs/ClientInput';
import { Edit, NumberInput, SimpleForm, TextInput } from 'react-admin';

export const FinancialReserveEdit: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const redirect = (basePath: any, id: any, data: any) => {
    return `Client/${data.client.id}/show/financialReserves`;
  };

  return (
    <Edit mutationMode="pessimistic" redirect={redirect}>
      <SimpleForm>
        <ClientInput disabled={true} label="Klient" source="client.id" />
        <TextInput label="Forma finančnej rezervy" source="text" sx={{ maxWidth: '40em', width: '100%' }} />
        <NumberInput label="Suma" required source="amount.amount" />
      </SimpleForm>
    </Edit>
  );
};
